import Vue from 'vue'
import AdventureCampus from '~/pages/AdventureCampus.vue'
import SvgIcon from '~/tags/SvgIcon.vue.js'

Vue.component('svg-icon', SvgIcon)

new Vue({
  el: '#app',
  render: h => h(AdventureCampus)
})



// WEBPACK FOOTER //
// ./src/entries/adventure.js